import dayjs from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import updateLocale from "dayjs/plugin/updateLocale";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

export const setLocale = (locale: string) => {
    dayjs.locale(locale);
    dayjs.updateLocale(locale, {});
};

//! set timezone
export const setTimezone = (timezone: string) => {
    dayjs.tz.setDefault(timezone);
};
export default dayjs;
